<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.09845 5.27292C8.33604 5.52331 8.32567 5.91891 8.07528 6.1565L4.67801 9.38015L16.8948 9.38015C17.24 9.38015 17.5198 9.65997 17.5198 10.0052C17.5198 10.3503 17.24 10.6302 16.8948 10.6302L4.67796 10.6302L8.07528 13.8539C8.32567 14.0914 8.33604 14.487 8.09845 14.7374C7.86085 14.9878 7.46526 14.9982 7.21487 14.7606L2.68112 10.4586C2.55676 10.3405 2.48633 10.1766 2.48633 10.0052C2.48633 9.83373 2.55676 9.66981 2.68112 9.5518L7.21487 5.24975C7.46526 5.01216 7.86085 5.02253 8.09845 5.27292Z"
    fill="#E2E2E2" />
</template>
